var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{},[_c('div',{staticClass:"hero-section"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.comp.task))]),_c('p',{staticClass:"page-subtitle"},[_vm._v(" "+_vm._s(_vm.comp.f1)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }